module.exports = __webpack_public_path__ + "img/efd7867.svg";